import axios from "axios"


const deletePhoto = id => {
  return axios
    .delete(`/profiles/images/${id}`)
    .then(response => {
      console.log("response from token auth", response.status)
      return response.data
    })
    .catch(response => {
      //acctions in case of error in server
      console.log("rerrr", response)
      return null
    })
}
const deleteVideo = id => {
  return axios
    .delete(`/profiles/videos/${id}`)
    .then(response => {
      console.log("response from token auth", response.status)
      return response.data
    })
    .catch(response => {
      //acctions in case of error in server
      console.log("rerrr", response)
      return null
    })
}

const setListingPhoto = id => {
  return axios
    .get(`/listing/${id}`)
    .then(response => {
      console.log("response from token auth", response.status)
      return response.data
    })
    .catch(response => {
      //acctions in case of error in server
      console.log("rerrr", response)
      return null
    })
}

const getObjects = collectionDBname => {
  return axios
    .get(`/panel/${collectionDBname}`)
    .then(response => {
      console.log("response from token auth", response.status)
      return response.data
    })
    .catch(response => {
      //acctions in case of error in server
      console.log("rerrr", response)
      return null
    })
}

function getActiveObjects() {
  return axios
    .get(`/activeCities`)
    .then(response => {
      console.log("response from token auth", response.status)
      return response.data
    })
    .catch(response => {
      //acctions in case of error in server
      console.log("rerrr", response)
      return null
    })
}

const saveObject = (collectionDBname, object) => {
  /*   let options = {
    body: object,
  } */
  return axios
    .post(`/update/${collectionDBname}`, object)
    .then(response => {
      console.log("response from save", response.status)
      return response.data
    })
    .catch(response => {
      //acctions in case of error in server
      console.log("rerrr", response)
      return null
    })
}
const createObject = (collectionDBname, object) => {
  /*   let options = {
    body: object,
  } */
  return axios
    .post(`/create/${collectionDBname}`, object)
    .then(response => {
      console.log("response from create", response.status)
      return response.data
    })
    .catch(response => {
      //acctions in case of error in server
      console.log("rerrr", response)
      return null
    })
}
const deleteObject = (collectionDBname, object) => {
  /*   let options = {
    body: object,
  } */
  return axios
    .post(`/remove/${collectionDBname}`, object)
    .then(response => {
      console.log("response from create", response.status)
      return response.data
    })
    .catch(response => {
      //acctions in case of error in server
      console.log("rerrr", response)
      return null
    })
}

export default {
  getObjects,
  saveObject,
  createObject,
  deleteObject,
  setListingPhoto,
  deletePhoto,
  deleteVideo,
  getActiveObjects,
}
